/* @flow */

/**
 * COPIED (with import modifications) FROM EndUserApp src/components/core/resin/components/ResinPage.js
 */

import { Children, Component } from 'react';
import get from 'lodash/get';

const DATA_RESIN_PAGE = 'data-resin-page';

type Props = {
  children?: any, // required,
  pageName: string,
};

class ResinPage extends Component<Props> {
  componentDidMount() {
    const docBody = get(document, 'body');
    const currentPageName = docBody.getAttribute(DATA_RESIN_PAGE);
    const { pageName } = this.props;
    if (pageName === currentPageName) {
      return;
    }

    docBody.setAttribute(DATA_RESIN_PAGE, pageName);
  }

  componentDidUpdate(prevProps: Props) {
    const { pageName } = this.props;
    if (prevProps.pageName !== pageName) {
      if (document.body) {
        document.body.setAttribute(DATA_RESIN_PAGE, pageName);
      }
    }
  }

  render() {
    const { children } = this.props;
    return Children.only(children);
  }
}

export default ResinPage;
